import { FC } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import * as Sentry from '@sentry/nextjs';
import { useSetAtom } from 'jotai';
import useLogin from 'src/hooks/useLogin';
import { GetGoogleUserInfoAPI } from 'src/stores/auth/apis';
import { socialTokenAtom, tryLoginTypeAtom } from 'src/stores/auth/atoms';
import { showToastAtom } from 'src/stores/toast/atoms';
import { LoginType } from 'src/types/register';
import { ToastType } from 'src/types/Toast';
import { SSOSocialToken } from 'src/types/Token';
import { isPwaMode } from 'src/utils/device/info';
interface Props {
  render: FC<{
    onClick: () => void;
  }>;
}
export default function LoginGoogle({
  render
}: Props) {
  const {
    loginOAuth
  } = useLogin();
  const showToast = useSetAtom(showToastAtom);
  const setTryLoginType = useSetAtom(tryLoginTypeAtom);
  const setSocialToken = useSetAtom(socialTokenAtom);
  const handleInfo = (loginType: LoginType, token: SSOSocialToken) => {
    setTryLoginType(loginType);
    setSocialToken(token);
    const {
      accessToken,
      id
    } = token;
    loginOAuth({
      accessToken,
      id
    });
  };
  const isPwa = isPwaMode();
  const onClick = useGoogleLogin({
    // scope: 'https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/user.gender.read',
    scope: 'https://www.googleapis.com/auth/userinfo.profile',
    flow: 'auth-code',
    ...(isPwa && {
      ux_mode: 'redirect',
      redirect_uri: location.origin
    }),
    onSuccess: async ({
      code
    }) => {
      try {
        const [{
          data: {
            accessToken
          }
        }
        /*
        {
        data: {
          genders: [{ value: gender }] = [{ value: undefined }],
          birthdays: [{ date: birthday }] = [{ date: undefined }],
        },
        }
        */] = await GetGoogleUserInfoAPI(code);
        handleInfo(LoginType.GOOGLE, {
          accessToken
          /*
          birth: (birthday?.year && birthday?.month >= 0 && birthday?.day) ? new Date(
            birthday.year,
            birthday.month - 1,
            birthday.day,
          ) : undefined,
          gender: gender?.toUpperCase(),
          */
        });
      } catch (error) {
        showToast({
          type: ToastType.ERROR,
          message: 'LOGIN__ERROR'
        });
        Sentry.captureException('[Google Login] - /api/v1/accounts/google/token API Error', {
          extra: {
            error
          }
        });
      }
    },
    onError: error => {
      showToast({
        type: ToastType.ERROR,
        message: 'LOGIN__ERROR'
      });
      Sentry.captureException('[Google Login] - useGoogleLogin onError', {
        extra: {
          error
        }
      });
    }
  });
  return render({
    onClick
  });
}